export function OutlinePreferenciasDeUbicacionIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3271 0.75C3.9172 0.75 0.291638 10.5635 5.24916 16.1422L7.80558 18.7046L12.3271 23.25L16.8725 18.7046L19.2318 16.3453C24.4222 10.7965 20.8206 0.75 12.3271 0.75ZM12.7989 5.60001L13.5157 7.80402C13.5814 8.01307 13.7785 8.15642 13.9995 8.15642H16.317C16.8127 8.15642 17.0158 8.78955 16.6156 9.07625L14.7401 10.4381C14.5609 10.5695 14.4893 10.7965 14.555 11.0055L15.2717 13.2095C15.427 13.6754 14.8895 14.0696 14.4893 13.7769L12.6138 12.4151C12.4346 12.2837 12.1957 12.2837 12.0165 12.4151L10.141 13.7769C9.7408 14.0696 9.20324 13.6754 9.35854 13.2095L10.0753 11.0055C10.141 10.7965 10.0693 10.5635 9.89012 10.4381L8.01463 9.07625C7.61444 8.78358 7.82349 8.15642 8.31327 8.15642H10.6308C10.8518 8.15642 11.0489 8.01307 11.1146 7.80402L11.8313 5.60001C11.9866 5.13412 12.6496 5.13412 12.7989 5.60001Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}
